module.exports = __webpack_public_path__ + "4c20055dd8159e3b0be3f669bf1f12f3.svg";